import React from "react";
import Box from "../Box";
import Stack from "../Stack";
import { Platform, StatusBar, SafeAreaView } from "react-native";
import { DistributionType } from "../Stack/Stack-types";

const safeAreStyles = {
  paddingTop: Platform.OS === "android" ? StatusBar.currentHeight : 0,
};

const webStyles =
  Platform.OS === "web"
    ? {
        container: {
          maxWidth: 768,
          margin: "auto",
          width: "100%",
        },
      }
    : {};

interface PropTypes {
  logoRenderer?: React.ReactNode;
  actionRenderer?: React.ReactNode;
  bottomRenderer?: React.ReactNode;
  secondaryActionRenderer?: React.ReactNode;
}

function Header(props: PropTypes) {
  let {
    actionRenderer,
    logoRenderer,
    bottomRenderer,
    secondaryActionRenderer,
  } = props;
  let stackDistribution: DistributionType =
    actionRenderer || secondaryActionRenderer ? "space-between" : "center";

  return (
    <Box bg="primary.main">
      <SafeAreaView
        style={{ paddingBottom: 0, ...safeAreStyles, ...webStyles.container }}
      >
        <Stack distribution={stackDistribution} alignment="center" p="l">
          {actionRenderer || <Box style={{ width: 36 }} />}
          {logoRenderer}
          {secondaryActionRenderer || <Box style={{ width: 36 }} />}
        </Stack>
        {bottomRenderer}
      </SafeAreaView>
    </Box>
  );
}

export default Header;
